import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';

@Injectable()
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string): Observable<Translation> | Promise<Translation> {
    const hash = Math.random().toString(36).substring(5);
    return this.http.get<Translation>(`/assets/i18n/${lang}.json?nc=${hash}`);
  }
}
